import { useTenantMe } from '@/api/tenants/use-tenant-me';

export interface CommercialModuleStates {
  /** Modulo Magazzino (inventario fisico compreso). */
  isWarehouseIncluded: boolean;
  /** API pubbliche e chiavi API. */
  isApiAccessIncluded: boolean;
}

/**
 * Moduli compresi nel contratto del tenant (listino 2026-10), da
 * `GET /tenants/:tenantId/me`. Finché il tenant carica, o con un backend che
 * non li espone, tutto resta visibile: è il comportamento dei contratti
 * precedenti, e il backend blocca comunque l'accesso.
 */
export function resolveCommercialModuleStates(
  modules: { WAREHOUSE: boolean; API_ACCESS: boolean } | undefined
): CommercialModuleStates {
  return {
    isWarehouseIncluded: modules?.WAREHOUSE !== false,
    isApiAccessIncluded: modules?.API_ACCESS !== false,
  };
}

export function useCommercialModules(): CommercialModuleStates {
  const { data } = useTenantMe();
  return resolveCommercialModuleStates(data?.commercialModules);
}
